module.exports = __webpack_public_path__ + "static/media/operations.2f57f8e3.png";